const breakpoints = require('./breakpoints');

let sizeMappings = {};

function init(config) {
	_validateSizeMappings(config);

	sizeMappings = config;
}

function _validateSizeMappings(sms) {
	const breakpointNames = Object.keys(breakpoints.getBreakpoints());

	Object.keys(sms).forEach((type) => {
		Object.keys(sms[type]).forEach((breakpoint) => {
			const sizeMapping = sms[type][breakpoint];

			if (breakpointNames.indexOf(breakpoint) === -1) {
				throw new Error(`Size mapping '${type}' contains an unknown breakpoint '${breakpoint}'.`);
			}

			if (sizeMapping === 'fluid') {
				return;
			}

			if (!Array.isArray(sizeMapping)) {
				throw new Error(`Breakpoint '${breakpoint}' of size mapping '${type}' isn't an array.`);
			}

			sizeMapping.forEach((size) => {
				if (size === 'fluid') {
					return;
				}

				if (Array.isArray(size) && size.length === 2
					&& typeof size[0] === 'number' && typeof size[1] === 'number'
					&& size[0] > 0 && size[1] > 0) {
					return;
				}

				throw new Error(`Invalid size in breakpoint '${breakpoint}' of size mapping '${type}'.`);
			});
		});
	});
}

function getSizeMapping(type) {
	return typeof sizeMappings[type] === 'undefined' ? {} : sizeMappings[type];
}

module.exports = {
	init,
	getSizeMapping
};
